import { TypeServiceEnum } from 'features/salesOrder/types';

export const QUICK_EDIT_SUPPORTED_TYPES = new Set<TypeServiceEnum>([
	TypeServiceEnum.Flight,
	TypeServiceEnum.FlightAncillary,
	TypeServiceEnum.Accommodation,
	TypeServiceEnum.Transfer,
	TypeServiceEnum.Other,
	TypeServiceEnum.Fee,
]);
